// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import type { ErrorType } from '@/Pages/Error/types/errorLocationState';
import error from '@/i18n/locales/pt-BR/error.json';

export const errorCopy = error satisfies {
  supportUrl: string;
  actions: { retry: string; home: string; support: string };
  types: Record<ErrorType, { title: string; description: string; iconAlt: string }>;
};

export function getErrorCopy(errorType: ErrorType) {
  return errorCopy.types[errorType];
}
